import { AxiosError, AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchAllMyPageTopicGroupDetails,
  fetchAllMyPageTopicData,
  postMyPageTopicGroups,
} from '@/Axios/api/myPage';
import { MyPageTopicGroupDetail } from '@/Interfaces/I_MyPage';
import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import {
  getMyPageTopicGroups,
  getMyPageTopics,
  setErrorMessage,
  setMyPageTopicGroups,
  setMyPageTopics,
  updateMyPageTopicGroups,
} from '../slices/MyPageSlice';

function* handleGetMyPageCategories() {
  try {
    const data: AxiosResponse = yield call(fetchAllMyPageTopicGroupDetails);
    yield put(setMyPageTopicGroups(data.data));
  } catch (e) {
    yield put(setErrorMessage(e));
  }
}

function* handleGetMyPageTopics() {
  try {
    const data: AxiosResponse = yield call(fetchAllMyPageTopicData);
    yield put(setMyPageTopics(data.data));
  } catch (e) {
    yield put(setErrorMessage(e));
  }
}

function* handleUpdateMyPageCategories(action: PayloadAction<MyPageTopicGroupDetail[]>) {
  try {
    const response: AxiosResponse = yield call(postMyPageTopicGroups, action.payload);
    yield put(setMyPageTopicGroups(response.data));
    message.success({
      content: 'MyPage Category updated successfully',
      duration: 3,
      style: {
        marginTop: '120px',
      },
    });
  } catch (e: unknown) {
    const error = e as AxiosError;
    yield put(setErrorMessage(error.response?.data.message));
    message.error({
      content: error.response?.data.message,
      duration: 3,
      style: {
        marginTop: '120px',
      },
    });
  }
}

export function* watchGetMyPageCategories() {
  yield takeLatest(getMyPageTopicGroups.type, handleGetMyPageCategories);
}

export function* watchGetMyPageTopics() {
  yield takeLatest(getMyPageTopics.type, handleGetMyPageTopics);
}

export function* watchUpdateMyPageCategories() {
  yield takeLatest(updateMyPageTopicGroups.type, handleUpdateMyPageCategories);
}
